import { FC, ReactNode } from 'react';
import { Stack } from '@mui/material';
import Icon from '../icon';
import Text from '../text';
import { IconType } from '../icon/helpers';

interface Props {
  icon?: IconType;
  title: ReactNode;
  children?: ReactNode;
}

const CardHeader: FC<Props> = ({ icon, title, children = null }) => {
  const hasIcon = !!icon;

  return (
    <Stack direction="row" gap={1} mb={2} alignItems="center">
      {hasIcon && <Icon name={icon} />}
      <Text bold>{title}</Text>
      <Stack direction="row" flexGrow={1} justifyContent="flex-end">
        {children}
      </Stack>
    </Stack>
  );
};

export default CardHeader;
